import {Link} from "react-router-dom";
import stringHelper from "../../helpers/string-helper";
import {useTranslation} from "react-i18next";

const ProviderItem = props => {

    const {provider} = props

    const {i18n} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language

    return (
            <Link
                to={stringHelper.getLocalizedPath(currentLanguage, `/providers/${provider.identifier}`)}
                className="partner">
                <img
                    className="partner__logo"
                    src={provider?.image}
                    loading={'lazy'}
                    alt={provider.identifier}
                />
                <div className="swiper-lazy-preloader"></div>

            </Link>
    )

}

export default ProviderItem
